module.exports = __webpack_public_path__ + "img/lifecoach.4d2cea2f.jpg";